import { SystemFuncArgs } from '@brochington/ecstatic';
import MoveMarkupInteraction from 'editor/components/interactions/MoveMarkupInteraction';
import Markup from 'editor/components/Markup';
import { Components } from '../components';

function moveRectangle(mc: Markup, interaction: MoveMarkupInteraction): void {
  const { currentX, currentY, deltaX, deltaY } = interaction;

  if (!mc.mkMarkup) {
    return;
  }

  const [left, bottom, right, top] = mc.mkMarkup.getRect();
  const width = right - left;
  const height = top - bottom;

  const newLeft = currentX - deltaX;
  const newBottom = currentY - deltaY;

  mc.mkMarkup.setRect(newLeft, newBottom, newLeft + width, newBottom + height);
}

function moveLine(mc: Markup, interaction: MoveMarkupInteraction): void {
  const { currentX, currentY, deltaX, deltaY } = interaction;

  if (!mc.mkMarkup) {
    return;
  }

  const points = mc.mkMarkup.getPoints() as { x: number; y: number }[];
  const p1 = points[0];
  const p2 = points[1];

  const [left, bottom, right, top] = mc.mkMarkup.getRect();
  const width = right - left;
  const height = top - bottom;
  const cx = currentX;
  const cy = currentY;

  const newLeft = cx - deltaX;
  const newBottom = cy - deltaY;
  const newRight = newLeft + width;
  const newTop = newBottom + height;

  mc.mkMarkup.setRect(newLeft, newBottom, newRight, newTop);

  const nextP1 = {
    x: p1.x === left ? newLeft : newRight,
    y: p1.y === bottom ? newBottom : newTop,
  };

  const nextP2 = {
    x: p2.x === left ? newLeft : newRight,
    y: p2.y === bottom ? newBottom : newTop,
  };

  mc.mkMarkup.setPoints([nextP1, nextP2]);
}

function moveNewPunch(mc: Markup, interaction: MoveMarkupInteraction): void {
  const { currentX, currentY, deltaX, deltaY } = interaction;

  if (!mc.mkMarkup) {
    return;
  }

  const [left, bottom, right, top] = mc.mkMarkup.getRect();
  const width = right - left;
  const height = top - bottom;

  const newLeft = currentX - deltaX;
  const newBottom = currentY - deltaY;

  mc.mkMarkup.setRect(newLeft, newBottom, newLeft + width, newBottom + height);
}

function movePunch(mc: Markup, interaction: MoveMarkupInteraction): void {
  const { currentX, currentY, deltaX, deltaY } = interaction;

  if (!mc.mkMarkup) {
    return;
  }

  const [left, bottom, right, top] = mc.mkMarkup.getRect();
  const width = right - left;
  const height = top - bottom;

  const newLeft = currentX - deltaX;
  const newBottom = currentY - deltaY;

  mc.mkMarkup.setRect(newLeft, newBottom, newLeft + width, newBottom + height);
}

export const moveMarkupComponents = [Markup, MoveMarkupInteraction];

export function moveMarkup(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const mc = components.get(Markup);
  const interaction = components.get(MoveMarkupInteraction);

  if (!mc.mkMarkup) {
    return;
  }

  const markupType = mc.mkMarkup.getType();

  switch (markupType) {
    case 'Square':
      moveRectangle(mc, interaction);
      break;
    case 'Line':
      moveLine(mc, interaction);
      break;
    case 'FreeText':
      // For right now moving FreeText can be done with moveRectangle.
      // Might need to be changed in the future.
      moveRectangle(mc, interaction);
      break;
    case 'Circle':
      if (mc.isNewPunch) {
        moveNewPunch(mc, interaction);
      }
      if (mc.isPunch) {
        movePunch(mc, interaction);
      }
      break;
    default:
  }

  // guessing move might be dependent on type of Markup.
}
